class ResearchProofBlock {
  constructor(el) {
    this.el = el;
    this.observer = null;
    this.init();
  }

  init() {
    const fills = this.el.querySelectorAll('.research-proof__bar-fill');
    if (!fills.length) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (!isIntersecting) return;
          target.classList.add('research-proof__bar-fill--animated');
          this.observer.unobserve(target);
        });
      },
      { threshold: 0.3 }
    );

    fills.forEach((fill) => this.observer.observe(fill));
  }

  destroy() {
    this.observer?.disconnect();
  }
}

const instances = new WeakMap();

function mount(el) {
  if (instances.has(el)) instances.get(el).destroy();
  instances.set(el, new ResearchProofBlock(el));
}

document.querySelectorAll('.research-proof').forEach(mount);

document.addEventListener('shopify:block:select', ({ target }) => {
  const el = target.querySelector('.research-proof');
  if (el) mount(el);
});

document.addEventListener('shopify:section:load', ({ target }) => {
  target.querySelectorAll('.research-proof').forEach(mount);
});
